module.exports = __webpack_public_path__ + "img/wechat.6f39427d.png";